/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const TeamsAppMessages = defineMessages({
  createYourTeamsApp: {
    id: 'MicrosoftTeams.TeamsAppMessages.createYourTeamsApp',
    defaultMessage: 'Create your Teams app'
  },
  title: {
    id: 'MicrosoftTeams.TeamsAppMessages.title',
    defaultMessage: 'Teams app'
  },
  descriptionOne: {
    id: 'MicrosoftTeams.TeamsAppMessages.descriptionOne',
    defaultMessage:
      'Go to the <link>Developer Portal</link> and log in with your credentials.'
  },
  descriptionTwo: {
    id: 'MicrosoftTeams.TeamsAppMessages.descriptionTwo',
    defaultMessage:
      'On the <strong>Apps</strong> tab, click <strong>New App</strong>. Enter your app name and click <strong>Add</strong>. Complete the required information and scroll to the <strong>Application (client) ID</strong> section to paste your Application (client) ID. Next, click <strong>Save</strong>.'
  },
  descriptionThree: {
    id: 'MicrosoftTeams.TeamsAppMessages.descriptionThree',
    defaultMessage:
      'Under the {configure} section, go to the {appFeatures}. Click the feature called {bot}. In the {selectExistingBot} dropdown, select the new bot you created in the previous step.'
  },
  configure: {
    id: 'MicrosoftTeams.TeamsAppMessages.configure',
    defaultMessage: 'Configure'
  },
  appFeatures: {
    id: 'MicrosoftTeams.TeamsAppMessages.appFeatures',
    defaultMessage: 'App features'
  },
  bot: {
    id: 'MicrosoftTeams.TeamsAppMessages.bot',
    defaultMessage: 'Bot'
  },
  selectExistingBot: {
    id: 'MicrosoftTeams.TeamsAppMessages.selectExistingBot',
    defaultMessage: 'Select an existing bot'
  },
  descriptionFour: {
    id: 'MicrosoftTeams.TeamsAppMessages.descriptionFour',
    defaultMessage:
      'Select the following scopes of use: {personal}, {team}, and {groupChat}. To finish, click {save}.'
  },
  personal: {
    id: 'MicrosoftTeams.TeamsAppMessages.personal',
    defaultMessage: 'Personal'
  },
  team: {
    id: 'MicrosoftTeams.TeamsAppMessages.team',
    defaultMessage: 'Team'
  },
  groupChat: {
    id: 'MicrosoftTeams.TeamsAppMessages.groupChat',
    defaultMessage: 'Group Chat'
  },
  save: {
    id: 'MicrosoftTeams.TeamsAppMessages.save',
    defaultMessage: 'Save'
  },
  descriptionFive: {
    id: 'MicrosoftTeams.TeamsAppMessages.descriptionFive',
    defaultMessage:
      'Click {publish} in the upper-right corner to publish your bot. Select the option that best fits your use case.'
  },
  publish: {
    id: 'MicrosoftTeams.TeamsAppMessages.publish',
    defaultMessage: 'Publish'
  },
  emptyClientId: {
    id: 'MicrosoftTeams.TeamsAppMessages.emptyClientId',
    defaultMessage: 'Fill in your application ID in the App registration tab.'
  }
});
